import NextImage from 'next/image';
import { FC } from 'react';

import { Icons, IconsTypes } from '@/components/shared/Icons';
import { Link } from '@/components/shared/Link';
import { IInteractiveMapPlant } from '@/types';

interface IPointWithData {
  plant: IInteractiveMapPlant;
}

const NAME_LIMIT = 20;

export const PointWithData: FC<IPointWithData> = ({ plant }) => {
  const { x_coord, y_coord, name, main_image_url, slug } = plant;

  const nameWithDots = name.length > NAME_LIMIT ? `${name.substring(0, NAME_LIMIT)}...` : name;

  return (
    <>
      <div
        className={`point absolute h-1 w-1 -translate-x-1/2 -translate-y-1/2 rounded-full hover:z-10 [&>div]:hover:z-30 [&>div]:hover:flex`}
      >
        <span className="absolute -left-[10px] bottom-0 [&>svg]:h-3 lg:[&>svg]:h-6">
          {Icons({ name: IconsTypes.LOCATION_PIN })}
        </span>

        <div className="absolute bottom-5 left-0 hidden w-[120px] cursor-pointer items-center rounded-lg border-[2px] border-green bg-white p-2">
          <Link href={`/plant/${slug}`}>
            <NextImage
              className="h-24 w-24 rounded-full object-cover"
              src={main_image_url ?? '/'}
              height={100}
              width={100}
              alt={name}
            />
            <h3 className="mt-2 text-center text-[10px] font-normal  leading-[12px]">{nameWithDots}</h3>
          </Link>
        </div>
      </div>
      <style jsx>{`
        .point {
          top: ${y_coord}%;
          left: ${x_coord}%;
        }
      `}</style>
    </>
  );
};
